import { render } from "./playlistCheck.vue?vue&type=template&id=5dcfc496"
const script = {}
script.render = render

export default script